<template>
  <v-container class="background mx-auto" fluid>
    <v-row justify="center">
      <h1
        class="secondary--text text-center font-weight-medium"
        :class="$vuetify.breakpoint.mdAndUp ? 'text-h2' : 'text-h3'"
      >
        <!-- {{ $t("$vuetify.accounts.pageTexts.mainTitle") }}
        <span class="fontGrey--text"> prime </span> -->
        <!-- אנחנו עוברים לאיזור האישי... -->
        prime mobile
      </h1>
    </v-row>

    <v-row v-if="showLogin" justify="center">
      <v-col class="pa-3 mt-3 background" cols="12" md="4" lg="3" sm="6">
        <LoginPopup v-model="isLoading"/>
      </v-col>
    </v-row>
    <!-- Unregestered user  -->
    <v-row
      v-if="!isUser && !hasUsers"
      align="center"
      justify="center"
      dir="ltr"
    >
    <v-col cols="12" md="4" class="text-right" v-if="isLoading">
      
      <h1 class="fontGrey--text text-center" :class="$vuetify.breakpoint.smAndUp ? 'text-h3' : 'text-h5'">
      ...אנחנו עוברים לאיזור האישי
       </h1>
       <div  class="text-center pa-10">
      <v-progress-linear
        indeterminate
        color="secondary"       
      ></v-progress-linear>
    </div>
    </v-col>
      <v-col cols="12" md="4" class="text-right" v-if="!isLoading">
        <h1
          class="fontGrey--text text-right mr-md-n16 mr-lg-n16 mr-sm-0 mr-xs-0 mb-5"
          :class="$vuetify.breakpoint.smAndUp ? 'text-h2' : 'text-h4'"
        >
          האזור האישי
        </h1>
        <h2
          class="fontGrey--text text-right mr-md-n14 mr-lg-n14 mr-sm-0 mr-xs-0"
          :class="$vuetify.breakpoint.smAndUp ? 'text-h5' : 'text-h6'"
          dir="ltr"
        >
          ,לקוח יקר
          <br />
          <span class="mr-md-1 mr-lg-1 mr-sm-0 mr-xs-0">
            ,באזור האישי תוכל לצפות בפרטי המנויים שלך, ניצול החבילות
          </span>
          <br />
          <span class="mr-md-2 mr-lg-2 mr-sm-0 mr-xs-0"> .החשבונית וניתוחי שימוש </span>
        </h2>
        <h2
          class="fontGrey--text text-right mr-md-n10 mr-lg-n10 mr-sm-0 mr-xs-0"
          :class="$vuetify.breakpoint.smAndUp ? 'text-h5' : 'text-h6'"
        >
          :בנוסף, כאן ניתן לרכוש שירותים נוספים עבור כל מנוי
          <br />
          <span class="mr-md-1 mr-lg-1 mr-sm-0 mr-xs-0">
            חבילות נדידה לחו&quot;ל, מספרי טלפון נוספים לאותו מכשיר
          </span>
          <br />
          <span class="mr-md-2 mr-lg-2 mr-sm-0 mr-xs-0"> .תא קולי, הקלטת שיחות ושירותים נוספים </span>
        </h2>
        <h2
          class="fontGrey--text text-right mr-md-n5 mr-lg-n5 mr-sm-0 mr-xs-0"
          :class="$vuetify.breakpoint.smAndUp ? 'text-h5' : 'text-h6'"
        >
          חלק מהפעולות מצריכות זיהוי מאובטח של הלקוח
          <br />
          <span class="mr-md-1 mr-lg-1 mr-sm-0 mr-xs-0">
            ולכן מומלץ שהסלולרי שלך יהיה זמין בעת ביצוע הפעולות
          </span>
          <br />
          <span class="mr-md-2 mr-lg-2 mr-sm-0 mr-xs-0"> .לקבלת קוד אבטחה אם נדרש </span>
        </h2>
        <h2
          dir="ltr"
          class="fontGrey--text text-right mr-0"
          :class="$vuetify.breakpoint.smAndUp ? 'text-h5' : 'text-h6'"
        >
          ,האזור אישי הינו ברור וקל לשימוש
          <br />
          <span class="mr-md-1 mr-lg-1 mr-sm-0 mr-xs-0">
            אך אם נתקלת בבעיה או שאלה נשמח לעמוד לרשותך
          </span>
          <br />
          <span class="mr-md-2 mr-lg-2 mr-sm-0 mr-xs-0">
            ,באמצעות הטלפון
            <span class="success--text">
              055-3335555
            </span>
          </span>
          <br />
          <span class="mr-md-3 mr-lg-3 mr-sm-0 mr-xs-0">
            <span class="success--text">
              ,info@prime.co.il
          </span>
            המייל
          </span>
          <br />
          <span class="mr-md-4 mr-lg-4 mr-sm-0 mr-xs-0">
            ,ווטסאפ
            <span class="success--text">
              055-3335555
            </span>
          </span>
          <br />
          <span class="mr-md-5 mr-lg-5 mr-sm-0 mr-xs-0">
            .או הצ׳אט שלנו
          </span>
        </h2>
      </v-col>
      <v-col cols="12" md="4">
        <v-img :src="srcPhones" alt="phones" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import isNil from "lodash/isNil";
import { mapState } from "vuex";
import LoginPopup from "@/components/CommonComponents/Dialogs/LoginPopup";

export default {
  name: "AccountsView",
  components: {
    LoginPopup,
  },

  data() {
    return {
      isLoading: false,
      srcPhones: require("../assets/phonesMockNobg.png"),
    };
  },

  computed: {
    ...mapState({
      account: (state) => state.account.account,
      accountOwner: (state) => state.user.accountOwner,
      user: (state) => state.user.profile,
      users: (state) => state.account.accountUsers,
    }),
    isUser() {
      return !isNil(this.user);
    },
    isAccountUser() {
      return !isNil(this.account) && this.accountOwner;
    },
    hasUsers() {
      return !isNil(this.users);
    },
    showLogin() {
      return isNil(this.account) && isNil(this.user) ? true : false;
    },
    height() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 130;
        case "sm":
          return 180;
        case "md":
          return 130;
        case "lg":
          return 180;
        case "xl":
          return 250;
        default:
          return 200;
      }
    },
  },
};
</script>

<style lang="sass">

.v-btn__content
  display: block
.faded-grey
  background-color: rgba(0, 0, 0, 0.05)
.hover-glow
    box-shadow: 0 10px 25px 0 rgba(0, 0, 0, 0.1)
    &:hover
        box-shadow: rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px
        padding-bottom: 10px
        bottom: 12px
</style>
